import * as Account_Domain_Types           from "../actions/types";
import * as viewElements                    from "../../../infrastructure/actions/creators/view-elements";
import * as Infrastructure_Provider_Actions from "../../../infrastructure/actions/creators/provider";
import api                                  from "../../../api";
import { put, takeLatest, all, call }       from "redux-saga/effects";
class AccountAsyncInterface {
  constructor() {
    this.name = "AccountAsyncInterface";
  }

  * startLogin(action) {
    try {
        yield put( Infrastructure_Provider_Actions.activateLoadingStatus('Start_Login') );
        const loginData = yield call(
            api.fetch, {
                url: `/api/auth/login`,
                method: 'POST',
                data: {
                    user_email: action.payload.email,
                    user_password: action.payload.password,
                },
                type : 'auth'
            }
        );
        if(loginData){
          let date = new Date(Date.now() + 86400e3);
          date = date.toUTCString();
          document.cookie = "applicationAuth=Osman; secure; SameSite=None; expires=" + date;
          localStorage.setItem('token', loginData.token);
            yield all([
                put({ 
                    type: Account_Domain_Types.LOGIN_RESULT, 
                    payload: { 
                        data : loginData,
                    }
                }),
            ])
            // window.location = '/panel'
        }
        yield put( Infrastructure_Provider_Actions.deactivateLoadingStatus('Start_Login') );
    } catch(err){
        yield all([
          put(
            viewElements.createToast({
              position: "center top",
              type: "danger",
              title: "Sign in unsuccessfully!",
              message: `${
                (err.response && err.response.data.message) ||
                err.message ||
                action.t("Static_Unexpected_Error_Occured")
              }`,
            })
          ),
          put(
            Infrastructure_Provider_Actions.deactivateLoadingStatus(
              "Start_Login"
            )
          ),
        ]);
      }
    }
}

const accountSagaInterface = new AccountAsyncInterface();
export default function* accountConfigDomainAsyncInterface() {
  yield all([
    takeLatest(
      Account_Domain_Types.LOGIN_START,        accountSagaInterface.startLogin
    ),
  ]);
}
